<template>
  <div>
    <Table
        :key="initTable"
        ref="TableComponent"
        :body="{}"
        :title="'admin_accounts'"
        :fields="fields"
        :url="url"
        :show-search="false"
        :show-dropdown="false"
        :show-filters="false"
        :action-button="button"
        @actionButtonTab="actionButtonTab"
    >

      <template #cell(id)="data">
          <router-link :to="'/admin-management/' + data.item.id" style="width:55px;" class="badge badge-light-primary">U-{{ data.item.id }}</router-link>
      </template>
      <template #cell(created_at)="data">
        {{ data.item.created_at | formatDate }}
      </template>

      <template #cell(type)="data">
        {{ $t(data.item.type) }}
      </template>

      <template #cell(status)="data" >
        <span v-if="data.value === 2" class="text-danger">
          {{ $t("deleted") }}
        </span>

        <span v-else-if="data.value === 1" class="text-success">
          {{ $t("active") }}
        </span>

        <span v-else-if="data.value === 0">
          {{ $t("inactive") }}
        </span>
      </template>

      <template #cell(custom)="data">
        <div>
          <b-link :to="'/admin-management/' + data.item.id">
            <b-button
                v-b-tooltip.hover
                variant="outline-primary"
                size="sm"
                class="button-space"
                :title="$t('edit')"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
          </b-link>

          <b-button
              v-if="data.item.status != 2 && data.item.id !== authUser.id"
              v-b-tooltip.hover
              v-b-modal.approveModal
              :title="$t('delete')"
              class="button-space"
              variant="outline-danger"
              size="sm"
              @click="changeModalInfo('delete', 'Delete', 'Are you sure that you want to delete this User?', data.item.id)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
          <b-button
              v-if="data.item.status == 2 && data.item.id !== authUser.id"
              v-b-tooltip.hover
              v-b-modal.approveModal
              :title="$t('activate')"
              class="button-space"
              variant="outline-success"
              size="sm"
              @click="changeModalInfo('reactivate', 'Reactivate', 'Are you sure you want to reactivate this user?', data.item.id)"
          >
            <feather-icon icon="UserCheckIcon" />
          </b-button>

        </div>
      </template>

    </Table>
    <ApproveModal
        :text-content="modalText"
        :title="modalTitle"
    />
  </div>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BPagination,
  BTr,
  BTh,
  BButton,
  BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import CustomLoader from '@/components/Common/CustomLoader'
import Table from '@/components/Common/Table2.vue'
import ApproveModal from '@/components/Common/ApproveModal'
import i18n from '@/libs/i18n'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'

export default {
  name: 'UsersList',
  components: {
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BPagination,
    BTr,
    BTh,
    BButton,
    BLink,
    CustomLoader,
    Table,
    ApproveModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      button: {
        text: 'add_new',
        link: '',
        color: 'primary',
      },
      modalText: null,
      modalTitle: null,
      options: null,
      title: i18n.t('users_management'),
      fields: [
        {
          label: 'created_at',
          align: 'start',
          key: 'created_at',
          sortable: true,
        },
        {
          label: 'id',
          align: 'start',
          key: 'id',
          sortable: true,
          value: 'id',
        },
        {
          label: 'full_name',
          align: 'start',
          key: 'full_name',
          sortable: true,
          value: 'full_name',
        },
        {
          label: 'email',
          align: 'start',
          key: 'email',
          sortable: true,
          value: 'email',
        },
        {
          label: 'status',
          key: 'status',
          customSlot: true,
          sortable: true,
          value: 'status',
        },
        {
          label: 'type',
          align: 'start',
          key: 'type',
          sortable: true,
        },
        {
          text: '',
          customSlot: true,
          key: 'custom',
          class: 'text-right minWidth220',
          value: 'custom',
        },
      ],
      items: [],
      user: null,
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 12,
      status: [],
      isLoading: false,
      totalItems: 0,
      approveModalAction: null,
      url: '/admin-management',
      idToChange: '',
      initTable: 'init',
      searchQuery: '',
    }
  },
  computed: {
    rows() {
      return this.totalItems
    },
    authUser() {
      return this.$store.state.auth.user;
    }
  },
  created() {
    this.getApiData()
  },

  methods: {
    actionButtonTab() {
      this.$router.push('/admin-management/create')
    },

    callApproveModalAction() {
      if (this.approveModalAction === 'delete') {
        this.deleteUser(this.idToChange)
      } else if (this.approveModalAction === 'reactivate') {
        this.reactivateUser(this.idToChange)
      }
    },

    reactivateUser(id) {
      this.$http.post(`user/admin/reactivate/${id}`).then(res => {
        if (res) {
          this.initTable = Math.random()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Admin reactivated successfully',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        }
      })
      if (this.$route.path !== '/admin-management') {
        this.$router.push('/admin-management')
      }
    },
    deleteUser(id) {
      this.$http.post(`user/admin/delete/${id}`).then(res => {
        if (res) {
          this.initTable = Math.random()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Admin deleted successfully',
              icon: 'SuccessIcon',
              variant: 'success',
            },
          })
        }
      })
      if (this.$route.path !== '/admin-management') {
        router.push('/admin-management')
      }
    },

    changeModalInfo(action, title, text, id) {
      this.idToChange = id
      this.modalText = text
      this.modalTitle = title
      this.approveModalAction = action
    },
    getApiData() {
      this.isLoading = true
      this.items = []
      this.$http
          .post(`/user/admin/list?page=${this.page}`, {
            status: this.status,
            options: null,
            filters: this.filters,
            search: this.search,
          })
          .then(response => {
            if (response.data.status == 200) {
              this.items = response.data.value.data
              this.totalItems = response.data.value.total
              this.page = response.data.value.current_page
            }
            this.isLoading = false
          })
          .catch(error => {
            this.isLoading = false
          })
    },

  },
}
</script>

<style scoped>
.button-space {
  margin-right: 5px;
}
</style>
